import Vue from "vue";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
ElementUI.Dialog.props.lockScroll.default = false;
import App from "./App";
import router from "./router";
import topNav from "@/components/top-nav.vue"
import sidebar from "@/components/sidebar.vue"
import bottomTitle from "@/components/bottom-title"
import pageControl from "@/components/page-control"
Vue.component("top-nav", topNav)
Vue.component("sidebar", sidebar)
Vue.component("bottom-title", bottomTitle)
Vue.component("page-control", pageControl)

import './assets/style/bootstrap.css'
import './assets/bootstrap/js/jq-3.31'
import './assets/bootstrap/js/bootstrap.min.js'

import './assets/style/icon.css'
import './assets/style/font-awesome.min.css'
import './assets/style/common.css'
import './assets/style/link.css'
import './assets/style/style.css'

import './assets/wangeditor/style.css'
import './assets/wangeditor/index.js'

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor);

Vue.use(ElementUI);

import i18n from './lang/index.js'

new Vue({
  el: "#app",
  i18n,
  router,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js